export default function Info ({message, children}) {
	return (
		<div className="alert alert-info" role="alert">
			{message}
			{children}
		</div>
	);
};
